import {useState} from 'react'
import {useSelector} from 'react-redux'

import {useDistributedStorageClient} from '../../../../../DistributedStorage'
import type {AppState} from '../../../../../Root.store'

export const DistributedCacheKey = 'italySlotBannerDismissAlert'

export type UserBannerDismissAlertStatus = 'dismissed' | 'active' | 'error'

export interface UserBannerDismissAlertState {
  status: UserBannerDismissAlertStatus
  date: Date
}

export const useItalySlotBannerDismissAlert = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [bannerState, setBannerState] = useState<UserBannerDismissAlertState>()
  const userId = useSelector((state: AppState) => state.userProfile.userProfile?.id || '')

  const client = useDistributedStorageClient()

  const key = `${DistributedCacheKey}-${userId}`
  if (!bannerState) {
    client
      .getItem<UserBannerDismissAlertState>(key)
      .then((response) => setBannerState(response || {status: 'active', date: new Date()}))
      .catch(() => setBannerState({status: 'error', date: new Date()}))
      .finally(() => setIsLoading(false))
  }

  const dismissBanner = () => {
    const state: UserBannerDismissAlertState = {status: 'dismissed', date: new Date()}
    client
      .setItem(key, state)
      .then(() => setBannerState(state))
      .catch(() => setBannerState({status: 'error', date: new Date()}))
  }

  return {bannerState, dismissBanner, isLoading}
}
